
import React, { useState } from "react";
import { View, ScrollView, SafeAreaView, StyleSheet, Picker, Text, TouchableOpacity, Image } from "react-native";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import { i18n } from './../../../assets/lang/i18next';
const useStyles = makeStyles(() => ({
    textField: {
        width: "100%",
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,
        fontSize: 13,
        direction: "rtl",
        "& .MuiFormLabel-root": {
            color: "black",
            textAlign: 'right',
            fontFamily: 'IranSans',
            fontSize: 13, direction: 'rtl', width: '100%',
        },
        "& .MuiInputLabel-asterisk": {
            color: '#d12023',
            fontWeight: 900,
        },
        "& .MuiInputBase-input": {
            color: '#333', textAlign: 'center'
        },
        '& label.Mui-focused': {
            color: '#333',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'blue',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#333',
            },
        },

    },
    labelRoot: {
        right: 20,
    },
    shrink: {
        transformOrigin: "top right",
    },
    input: {
        color: "black", fontFamily: 'IranSans',
        fontSize: 13,

    },
    btn_calculate: {
        color: '#333',
        backgroundColor: 'gray',
        fontFamily: 'IranSans',
        fontSize: 13, fontWeight: 900,
    }
}));

const CondA8ByCalculate = props => {
    const { t, i18n } = useTranslation();

    const classes = useStyles();
    const [mobared, setmobared] = useState("R22");
    const [txtzarfiyatcond, settxtzarfiyatcond] = useState("");
    const [selectvahedzarfoyat, setSelectvahedzarfiyat] = useState(1);
    const [txtdeltat, setTxtdeltat] = useState("");
    const [txtdarya, settxtdarya] = useState("");
    const [txtdamaymohit, settxtdamaymohit] = useState("");


    function FUNCMOHASEBEH() {
        let fa = 1, qn = 0;
        switch (txtdarya) {
            case "0":
                fa = 1;
                break;
            case "200":
                fa = 1.013;
                break;
            case "400":
                fa = 1.027;
                break;
            case "600":
                fa = 1.042;
                break;
            case "800":
                fa = 1.058;
                break;
            case "1000":
                fa = 1.074;
                break;
            case "1200":
                fa = 1.09;
                break;
            case "1400":
                fa = 1.107;
                break;
            case "1600":
                fa = 1.124;
                break;
            case "1800":
                fa = 1.142;
                break;
            case "2000":
                fa = 1.16;
                break;
            case "2200":
                fa = 1.18;
                break;
            case "2400":
                fa = 1.201;
                break;
            case "2600":
                fa = 1.222;
                break;
            case "2800":
                fa = 1.243;
                break;
            case "3000":
                fa = 1.265;
                break;

        }

        qn = (parseFloat(txtzarfiyatcond * selectvahedzarfoyat) * parseFloat(fa) * 15) / parseFloat(txtdeltat);

        switch (mobared) {
            case "R22":
                qn = qn;
                break;
            case "R134":
                qn = parseFloat(qn) * parseFloat(1.05);
                break;
            case "R404a/R507a":
                qn = parseFloat(qn) * parseFloat(0.97);
                break;
        }


        qn = qn.toFixed(2);
        props.navigation.navigate('CondenserResult', { WHICH: 5, QN: qn });






    }

    return (
        <ScrollView>
            <SafeAreaView style={styles.container}>

                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', width: '90%' }}>
                    <TouchableOpacity style={{ marginTop: 15, flex: 1, flexDirection: 'row' }} onPress={() => props.navigation.navigate('CompCondonser')}>
                        <Image resizeMode="contain" source={require('../../../assets/icons/comparisonicon.png')} style={{ width: 35, height: 35 }} />
                        <Text style={{ fontSize: 12, marginTop: 7, fontFamily: 'IranSans', color: 'blue' }}>{t('ComparisonCondenser')}</Text>
                    </TouchableOpacity>
                    <Text style={{ fontFamily: 'IranSans', fontWeight: 900, fontSize: 14, marginTop: 15, marginBottom: 10 }}>{t('StaticCondenser85series')}</Text>
                </View>
                <View style={styles.form}>
                    <Text style={styles.titleform}>{t('selectyourrefrigerant')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setmobared(itemValue);
                        }}
                    >
                        <Picker.Item label="R22" value="R22" />
                        <Picker.Item label="R134" value="R34" />
                        <Picker.Item label="R404/R507a" value="R404/R507a" />

                    </Picker>

                    <TextField
                        label={t('CondenserCapacity')}
                        variant="filled"
                        placeholder={t('EnterCondenserCapacity')}
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => settxtzarfiyatcond(e.target.value)}
                        value={txtzarfiyatcond}
                        onFocus={(e) => e.target.select()}
                        onWheel={(e) => e.target.blur()}
                    />
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setSelectvahedzarfiyat(itemValue);
                        }}
                    >
                        <Picker.Item label={t('EvaporatorCapacitybasedonKW')} value="1" />
                        <Picker.Item label={t('basedonKCalhr')} value="859.845228" />
                        <Picker.Item label={t('Btuhr')} value="3412.116334" />
                        <Picker.Item label={t('TonTR')} value="0.284345" />
                    </Picker>

                    <TextField
                        label={t('DeltaTc')}
                        onFocus={(e) => e.target.select()}
                        variant="filled"
                        placeholder={t('acceptablerangebetween7and15')}
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => {
                            setTxtdeltat(e.target.value)
                        }}
                        value={txtdeltat}
                        onWheel={(e) => e.target.blur()}
                    />

                    <TextField
                        label={t('environmenttemperature')}
                        onFocus={(e) => e.target.select()}
                        variant="filled"
                        placeholder={t('evaporation')}
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => { settxtdamaymohit(e.target.value) }}
                        value={txtdamaymohit}
                        onWheel={(e) => e.target.blur()}
                    />
                    <TextField
                        label={t('Altitude')}
                        onFocus={(e) => e.target.select()}
                        variant="filled"
                        placeholder={t('Altitude')}
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => { settxtdarya(e.target.value) }}
                        value={txtdarya}
                        onWheel={(e) => e.target.blur()}

                    />


                    <TouchableOpacity onPress={() => {

                        FUNCMOHASEBEH();

                    }} style={{ backgroundColor: '#022a4c', color: 'white', padding: 15, margin: 15, borderRadius: 4 }}>
                        <Text style={styles.titlebutton}>
                            {t('Computing')}
                        </Text>
                    </TouchableOpacity>




                </View>
            </SafeAreaView>
        </ScrollView>
    )
}

export default CondA8ByCalculate;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#ebecec',

    }
    ,
    titleform: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    dropdown: {
        height: 50,
        width: '100%',
        marginBottom: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',



    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
    }
    ,
    touchable: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 32,
        borderRadius: 4,
        elevation: 3,
        backgroundColor: 'blue',
        marginBottom: 15,
        margin: 15,
    },
    titlebutton: {

        fontSize: 13,
        lineHeight: 21,
        fontWeight: 'bold',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white', textAlign: 'center'

    },
    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(50,70,110,0.3)',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
    }

});